import { render, staticRenderFns } from "./CascaderLazy.vue?vue&type=template&id=610e5e42&scoped=true"
import script from "./CascaderLazy.vue?vue&type=script&lang=js"
export * from "./CascaderLazy.vue?vue&type=script&lang=js"
import style0 from "./CascaderLazy.vue?vue&type=style&index=0&id=610e5e42&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "610e5e42",
  null
  
)

export default component.exports